export default function toArray(value) {
  if (Array.isArray(value)) {
    return [].concat(value);
  }
  return value !== undefined ? [value] : [];
}